<div class="content"><ng-content *ngIf="!submitting"></ng-content></div>
<mat-spinner *ngIf="submitting"
             class="inline"
             [diameter]="18"
             color="accent"
></mat-spinner>
